import React from 'react';
import styled from 'styled-components';
import EsItem from './EsItem';
import EsItemDone from './EsItemDone';
import EsItemNone from './EsItemNone';
import { Log } from '../../lib/util/CustomUtil';
import {isMobileOnly} from 'react-device-detect';
import moment from "moment";
import { useEffect } from 'react';
import { useState } from 'react';

const EsItemDoneListBlock = styled.div`
    ${isMobileOnly?`
    //padding-bottom: 20px;
    `:`
    ''
    `};

`;

const EsItemDoneListDateBlock = styled.div`
${isMobileOnly?`
    padding-left: 4vw;
    `:`
    ''
    `};
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #cccccc;
    margin-bottom: 20px;
`;

const EsItemDoneListContainerBlock = styled.div`
${isMobileOnly?`
        margin: 0 4vw;
        position: relative;
        padding: 20px 0px;
        margin-bottom: 30px;
    `:`
    padding: 40px 0px 50px;
    margin-bottom: 40px;
    `};

background-color: #ffffff;
  position: relative;
  
  
  &:after {
    //background: linear-gradient(-45deg, #f4f4f4 16px, transparent 0), linear-gradient(45deg, #f4f4f4 16px, transparent 0);
    background: linear-gradient(-135deg, #ffffff 16px , transparent 0), linear-gradient(135deg, #ffffff 16px , transparent 0) ;
    background: #f4f4f4;
            background-image: linear-gradient(-135deg, #ffffff 16px , transparent 0), linear-gradient(135deg, #ffffff 16px , transparent 0) ;

    background-position: left-bottom;
    background-repeat: repeat-x;
    background-size: 23px 32px;
    //clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    content: " ";
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 32px;
  }
`;

const EsItemDoneListLeftBlock = styled.div`
    ${isMobileOnly?`
    
    `:`
    float: left;
    width: 170px;
    `};
    
`;

const EsItemDoneListLeftInnerBlock = styled.div`
position: relative;
border-right: solid 1px #cccccc;
`;
const EsItemDoneListRightBlock = styled.div`
    ${isMobileOnly?`
    
    `:`
    float: left;
    width: 1006x;
    `};

    
`;

const EsItemStatusBlock = styled.div`
${isMobileOnly?`
    padding-left: 20px;
    `:`
    width: 170px;
    //padding: 80px 40px 48px;
    padding-left: 48px;
    `};
    
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #333333;

    &.black {
        color: #333333;
    }
    &.green {
        color: #79b88a;
    }
    &.gray {
        color: #999999;
    }
    &.pink {
        color: #fc1c67;
    }

`;

const EsItemDotlineBlock = styled.div`
    border-top: dotted 1px #cccccc;
    padding-top: 10px;
    /* padding: 10px 20px 0px; */
    margin: 0 20px;
`;
const EsItemDoneList = ({ esItems}) => {
    const [height, setHeight] = useState("100px");
    const { memo_type, memo_status, dday, od_id, od_unpay, od_pay_type, } = esItems[0];

    useEffect(() => {
        // console.log("esItem : " + JSON.stringify(esItem))
        if (esItems !== null) {
            let height = 100*esItems.length;
            height += 30*(esItems.length-1)
            let size = height + "px";
            setHeight(size);
        }

    }, [esItems]);

    const getDate = () => {
        let esitem = esItems[0];
        return moment(esitem.od_reg_date).format('YY.MM.DD')

    }

    const getNumber = () => {
        let esitem = esItems[0];
        let text = "No. " + esitem.od_id;
        return text

    }

    const getStatusBtn = () => {
        let text="결제 완료";
        if(od_pay_type === '150402') {
            if(od_unpay*1 > 0) {
                if(dday > 0) {
                    text = "입금 대기"
                } else {
                    text = "입금 기한 만료"
                }
                
            } else {
                text = "입금 완료"
            }
        }

        if(memo_type === '151001' && memo_status === "151106") {
            text = "주문 취소"
        }

        if(isMobileOnly) {
            if(text === "주문 취소") {
                return <EsItemStatusBlock className="pink" >{text}</EsItemStatusBlock>
            } else if(text === "결제 완료" || text === "입금 완료") {
                return <EsItemStatusBlock className="black" >{text}</EsItemStatusBlock>
            } else if(text === "입금 대기") {
                return <EsItemStatusBlock className="green" >{text}</EsItemStatusBlock>
            }
            else if(text === "입금 기한 만료") {
                return <EsItemStatusBlock className="gray" >{text}</EsItemStatusBlock>
            }
            
            return <EsItemStatusBlock >{text}</EsItemStatusBlock>
        } else {
            if(text === "주문 취소") {
                return <EsItemStatusBlock className="pink" style={{height:height ,lineHeight:height}}>{text}</EsItemStatusBlock>
            } else if(text === "결제 완료" || text === "입금 완료") {
                return <EsItemStatusBlock className="black" style={{height:height ,lineHeight:height}}>{text}</EsItemStatusBlock>
            } else if(text === "입금 대기") {
                return <EsItemStatusBlock className="green" style={{height:height ,lineHeight:height}}>{text}</EsItemStatusBlock>
            }
            else if(text === "입금 기한 만료") {
                return <EsItemStatusBlock className="gray" style={{height:height ,lineHeight:height}}>{text}</EsItemStatusBlock>
            }
            
            return <EsItemStatusBlock style={{height:height ,lineHeight:height}}>{text}</EsItemStatusBlock>
        }

        

    }

    const getHeight = ()=> {
        
    }

    if (esItems === undefined) {
        return <EsItemDoneListBlock />
    }

    // 비로그인 상태이거나 견적서가 없을 때 표시 
    if (esItems === null || esItems.length === 0) {
        return <EsItemNone curIdx={1} />

    } else {
        /*  로딩 중 아니고, 견적 리스트 배열이 존재할 때만 보여줌 */
        return (
            <EsItemDoneListBlock>
                <EsItemDoneListDateBlock>{getNumber()}</EsItemDoneListDateBlock>
                {isMobileOnly ?
                <EsItemDoneListContainerBlock className="clearfix">
                    <div className="clearfix">
                    <EsItemDoneListLeftBlock className="clearfix">
                        <EsItemDoneListLeftInnerBlock>{getStatusBtn()}</EsItemDoneListLeftInnerBlock>
                        </EsItemDoneListLeftBlock>
                    <EsItemDoneListRightBlock className="clearfix">
                    {
                        esItems.map((item, index) => {
                            if (index > 0) {
                                return (
                                    <div>
                                    <EsItemDotlineBlock className="" />
                                        <EsItemDone esItem={item} key={index} last = {index === esItems.length -1}/>
                                    
                                    </div>
                                    )
                            } 
                            return <EsItemDone esItem={item} key={index} last = {index === esItems.length -1}/>
                        })
                    }
                    </EsItemDoneListRightBlock>
                    </div>
                </EsItemDoneListContainerBlock>
                :
                <EsItemDoneListContainerBlock className="clearfix">
                        <div className="clearfix">
                    <EsItemDoneListLeftBlock className="clearfix">
                        <EsItemDoneListLeftInnerBlock style={{height:height ,lineHeight:height}}>{getStatusBtn()}</EsItemDoneListLeftInnerBlock>
                        </EsItemDoneListLeftBlock>
                    <EsItemDoneListRightBlock className="clearfix">
                    {
                        esItems.map((item, index) => {
                            if (index > 0) {
                                return (
                                    <div className="margin_t-30">
                                        <EsItemDone esItem={item} key={index} last = {index === esItems.length -1}/>
                                    </div>
                                    )
                            } 
                            return <EsItemDone esItem={item} key={index} last = {index === esItems.length -1}/>
                        })
                    }
                    </EsItemDoneListRightBlock>
                    </div>
                </EsItemDoneListContainerBlock>
            }
                
            </EsItemDoneListBlock>
            
        );
    }



};

export default EsItemDoneList;